import axios from "axios"
import { createContext, useState, useEffect } from "react"
import { dvSrv } from "../hook/useDeepvinApi"

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({})
  // const navigate = useNavigate()

  useEffect(() => {
    // Listen for logout events from other tabs
    // This is a workaround for cross-tab communication in React
    // Using localStorage to broadcast logout events
    // Note: This won't work if localStorage is disabled
    const handleLocalStorageEvent = (e) => {
      if (e.key === 'logout') {
        setAuth({})
        // navigate('/', { replace: true });
        // full hard reload:
        window.location.reload();
      }
    }
    window.addEventListener('storage', handleLocalStorageEvent);
  
    axios.get(dvSrv + "/api/checktoken", {withCredentials: true})
    .then(({data}) => setAuth(data))
    .catch(error => {
      if (error.response?.status === 401) {
        setAuth({})
      } else { console.error("API error: ", error) }
    })

    return () => {
      window.removeEventListener('storage', handleLocalStorageEvent)
    }
  }, [])

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext